export default {
  gameSummary: {
    sections: {
      matchupInformation: "Informazioni matchup",
      rankings: "Ranking",
    },
    labels: {
      record: "Record",
      rank: "Ranking",
      type: "Tipo",
      stat: "Stat",
      filterByGame: "Filtra per partita",
      position: "Posizione",
      injury: "Infortunio",
      status: "Stato",
      trend: "Trend",
    },
    standingTypes: {
      division: "Division",
      conference: "Conference",
      league: "Lega",
      overall: "Complessivo",
    },
    rankingSides: {
      FOR: "A FAVORE",
      AGAINST: "CONTRO",
    },
    statAbbreviations: {
      PTS: "PTS",
      "SCORE %": "SCORE %",
      "SCORE%": "SCORE%",
      PLAYS: "GIOCATE",
      "NET YDS": "NET YDS",
      "PASS YDS": "PASS YDS",
      "PASS ATT": "TENT. PASS",
      "PASS COMPL": "PASS COMPLET.",
      "PASS TD": "PASS TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH ATT": "TENT. CORSA",
      "RUSH TD": "RUSH TD",
      "TOTAL TDS": "TOTAL TDS",
      "RZ%": "RZ%",
      "1D": "1D",
      "3D%": "3D%",
      "4D%": "4D%",
      INT: "INT",
      TO: "TO",
      SACKS: "SACKS",
      FUML: "FUML",
      G: "GOL",
      SOG: "SOG",
      SAT: "SAT",
      "CF%": "CF%",
      "PP%": "PP%",
      PIM: "PIM",
      PPG: "PPG",
      SHG: "SHG",
      "SH%": "SH%",
      BLK: "BLK",
      FTM: "FTM",
      FTA: "FTA",
      "FT%": "FT%",
      FGM: "FGM",
      FGA: "FGA",
      "FG%": "FG%",
      "3PTM": "3PTM",
      "3PTA": "3PTA",
      "3PT%": "3PT%",
      "TS%": "TS%",
      "eFG%": "eFG%",
      TRB: "RIMB",
      AST: "AST",
      STL: "RUB",
      R: "R",
      H: "H",
      "1B": "1B",
      "2B": "2B",
      "3B": "3B",
      TB: "TB",
      ER: "ER",
      HR: "HR",
      RBI: "RBI",
      BB: "BB",
      SO: "SO",
      E: "E",
      AVG: "AVG",
      OBP: "OBP",
      SLG: "SLG",
      OPS: "OPS",
      POS: "POS",
      SHO: "TIRI",
      SOT: "SOT",
      COR: "ANG",
      OFF: "OFF",
      FLS: "FALLI",
      "2YELRED": "2YELRED",
      YEL: "GIALLO",
      RED: "ROSSO",
      T: "P",
      "CR%": "CR%",
      RM: "RM",
      LB: "LB",
      K: "K",
      KM: "KM",
    },
    quickPicks: {
      moneyline: "Moneyline",
      spread: "Spread",
      total: "Totale",
    },
  },
};
